<template>
    <div class="flex-form__fieldset">
        <label class="flex-form__field">
            <div class="flex-form__label">
                Target

                <tooltip>
                    This determines which element the action will be ran on.
                </tooltip>
            </div>

            <dropdown v-model="dataNew.targetType" class="flex-form__dropdown" :options="targetTypes" />
        </label>

        <label v-if="dataNew.targetType === 'other'" class="flex-form__field" :class="getInvalidClass('targetId')">
            <div class="flex-form__label">
                Element ID

                <tooltip>
                    You can get the element ID by selecting the element, and then clicking on the fingerprint icon in its toolbar.
                </tooltip>
            </div>

            <input v-model="dataNew.targetId" class="flex-form__input">
        </label>
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'action-show',
    mixins: [eventDataMixin],

    computed: {
        schema() {
            return {
                targetType: {
                    type: String,
                    default: 'self',
                },

                targetId: {
                    type: String,
                    default: '',
                    required: this.dataNew.targetType !== 'self',
                },
            };
        },

        targetTypes() {
            return [
                { text: 'This Element', value: 'self' },
                { text: 'Other Element', value: 'other' },
            ];
        },
    },
};
</script>
